import { useContext, useEffect, useState } from "react";
import InputFilterBox from "../InputFilterBox/web"
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { currencyType } from "../options";
import { getLabelPriceRange } from "src/utils/Functions";
import './styles.less'
import { Price } from "shared-components/Components/Filters/Price/web_2";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";

export const RangePriceFilter = ({show}) => {
    if (!show) return null;
    
    const { filters } = useFilters();
    const { country_code } = useContext(ConfigStateContext);
	const { changeFiltersAndUpdateURL } = useSearchResultsFilters();

    const currenciesByCountry = currencyType.filter(currency => currency.countries.includes(country_code ? country_code.toUpperCase() : ""))
    const currenciesList = currenciesByCountry.map((currency) => ({ text: currency.text, value: currency.value, smallText: currency.smallText }));
    const [rangePriceDescription, setRangePriceDescription] = useState("Precio");

    useEffect(() => {
        const {symbol} = getCurrencyInfo(filters?.currencyID)
        const minPrice = filters?.minPrice ? filters?.minPrice.toString() : "";
        const maxPrice = filters?.maxPrice ? filters?.maxPrice.toString() : "";
        const label: string = getLabelPriceRange(minPrice, maxPrice, symbol);
        
        setRangePriceDescription(label)
    }, [filters?.minPrice, filters?.maxPrice, filters?.currencyID])

    const getCurrencyInfo = (value) => {
        let current = currenciesList[0];
        let symbol = '';
        const getCurrencySymbol = (currencyText) => currencyText.split(' ')[0];

        if (filters.currencyID) {
            current = currenciesList.find((currency) => currency.value === value) || currenciesList[0];
        }

        if (current) symbol = getCurrencySymbol(current.text);

        return {symbol, currency: current}
    }

    const handleCleanFilter = () => {
        const valuesToReset = {
            currencyID: { text: null, value: filters?.currencyID },
            minPrice: null,
            maxPrice: null,
            commonExpenses: null
        }

        changeFiltersAndUpdateURL(valuesToReset)
    }

    return (
        <InputFilterBox
            active={filters?.minPrice > 0 || filters?.maxPrice > 0}
            label={rangePriceDescription}
            customWidth={country_code === 'CO' ? 200 : 280}
            onCancelFilter={handleCleanFilter}
            scrollable
        >
            <div className="optionList add-padding remove-hr">
                <Price showTitle={false} showCta changeFilters={changeFiltersAndUpdateURL} filters={filters} show={show} verticalOptions={country_code === 'CO'}/>
            </div>
        </InputFilterBox>
    )
}